import { DictionaryUUIDsEnum } from 'CorePackage/DictionariesModule/enums/DictionaryUUIDsEnum';
import { IDictionaryChecklistSelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionaryChecklistSelectOption';

export const NEW_CHECKLIST_SELECT_OPTION_CODE = 'new';

export const newChecklistSelectOption: IDictionaryChecklistSelectOption = {
  id: null,
  code: NEW_CHECKLIST_SELECT_OPTION_CODE,
  title: null,
  questions: null,
  label: 'Создать новый',
  value: {
    dictId: DictionaryUUIDsEnum.CHECKLIST,
    dictVersionId: '',
  },
};
